import React from "react";

import Div from "@components/Div";
import JSONViewer from "@components/JSONViewer";

import { useRawDataTab } from "./RawDataTab.hooks";

const RawDataTab = () => {
  const { jsonData } = useRawDataTab();

  return (
    <Div>
      <JSONViewer data={jsonData} />
    </Div>
  );
};

export default RawDataTab;
